import type { FC } from 'react';
import clsx from 'clsx';

interface ModalButtonBarProps {
  cancelLabel?: string;
  onCancel?: () => void;
  confirmLabel: string;
  onConfirm: () => void;
  hideCancel?: boolean;
  variant?: 'default' | 'add-new-address';
}

const ModalButtonBar: FC<ModalButtonBarProps> = ({
  cancelLabel,
  onCancel,
  confirmLabel,
  onConfirm,
  hideCancel = false,
  variant = 'default'
}) => (
  <div
    className={clsx(
      'modal-pickup__btns-wrapper1',
      variant === 'add-new-address' && 'add-new-address'
    )}
  >
    {!hideCancel && cancelLabel && onCancel ? (
      <div
        onClick={onCancel}
        className='modal-pickup__btn modal-pickup__btn--close-btn'
      >
        {cancelLabel}
      </div>
    ) : null}
    <div
      onClick={onConfirm}
      className='modal-pickup__btn modal-pickup__btn--confirm-btn'
    >
      {confirmLabel}
    </div>
  </div>
);

export default ModalButtonBar;
